import React from "react";
import moment from "moment";
import times from "lodash/times";
import { MenuItem } from "@material-ui/core";
import { Field } from "redux-form/immutable";

import TextField from "app/components/form/TextField";

const HOURS_PER_DAY = 24;

const HoursDropDown = ({ renderTextField, name, ...rest }) => {
  const now = moment({ hours: 0 });

  return (
    <Field select name={name} component={TextField} label="hh" {...rest}>
      {times(HOURS_PER_DAY, hour => (
        <MenuItem key={hour} value={hour}>
          {now
            .clone()
            .add(hour, "hours")
            .format("HH")}
        </MenuItem>
      ))}
    </Field>
  );
};

export default React.memo(HoursDropDown);
